"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dashboard = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
const react_native_1 = require("react-native");
const Dashboard_web_style_1 = require("./Dashboard.web.style");
const react_1 = __importStar(require("react"));
const User_service_1 = __importDefault(require("../../../services/User.service"));
const organisms_1 = require("../../../components/organisms");
const atome_1 = require("../../../components/atome");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const AccountCreatedStep_component_1 = require("./AccountCreatedStep.component");
const UserInformationStep_component_1 = require("./UserInformationStep.component");
const ThirdCircleStep_component_1 = require("./ThirdCircleStep.component");
const FourthCircleStep_component_1 = require("./FourthCircleStep.component");
const FifthCircleStep_component_1 = require("./FifthCircleStep.component");
const FirstCurrentStep_component_1 = require("./FirstCurrentStep.component");
const ThirdCurrentStep_component_1 = require("./ThirdCurrentStep.component");
const FourthCurrentStep_component_1 = require("./FourthCurrentStep.component");
const PhoneSupportDesktop_component_1 = require("./PhoneSupportDesktop.component");
const NextStepFirstAppointment_component_1 = require("./NextStepFirstAppointment.component");
const NextStepFirstAppointmentTookPlace_component_1 = require("./NextStepFirstAppointmentTookPlace.component");
const NextStepLastStep_component_1 = require("./NextStepLastStep.component");
const PhoneSupportMobileTablet_component_1 = require("./PhoneSupportMobileTablet.component");
const PatientDeclined_1 = require("./PatientDeclined");
const StayTunedCurrentStep_web_component_1 = require("./StayTunedCurrentStep.web.component");
const date_fns_1 = require("date-fns");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
// @ts-ignore
function Dashboard({ navigation, setToggleBarUp, setUserInfo }) {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [scrollPosition, setScrollPosition] = (0, react_1.useState)(0);
    const [showFolgerezept, setShowFolgerezept] = (0, react_1.useState)(false);
    const [isTherapyModalVisible, setTherapyModalVisible] = (0, react_1.useState)(false);
    const [isModalVisibleConfirmDataMigration, setModalVisibleConfirmDataMigration,] = (0, react_1.useState)(false);
    const [isModalVisiblePharmacy, setModalVisiblePhmaracy] = (0, react_1.useState)(false);
    const aktuelRef = (0, react_1.useRef)(null);
    const isPatientDeclined = userInformation?.isPatientDeclined !== undefined &&
        userInformation?.isPatientDeclined === true;
    const getUserInfo = async () => await User_service_1.default.information();
    const getUserProgress = async () => await User_service_1.default.getProgress();
    const getAgreedDataMigrationCompany = async () => await User_service_1.default.getAgreedDataMigrationCompany();
    const isMyCannabisPharmacySet = async () => await User_service_1.default.isMyCannabisPharmacySet();
    const isNextDay = (date) => {
        return (0, date_fns_1.endOfDay)(new Date(date)) < (0, date_fns_1.startOfToday)();
    };
    const navigateTo = (screen, navigationParams) => {
        setToggleBarUp(false);
        setScrollPosition(1000);
        if (navigationParams) {
            navigation.navigate(screen, navigationParams);
            return;
        }
        navigation.navigate(screen);
    };
    const scrollToAktuel = (x, y, width, height, web) => {
        if (aktuelRef.current !== null) {
            aktuelRef.current.scrollTo({
                x: web ? x + width : 0,
                y: web ? 0 : y + 2 * height,
                animated: true,
            });
        }
    };
    const toComplete = () => {
        if (userInformation.progress.total === 0) {
            navigateTo('Splash');
        }
        else {
            navigateTo('CaseHistoryOverview');
        }
    };
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', () => {
            setLoading(true);
            if (auth.isAuthenticated) {
                let promises = [
                    getUserInfo(),
                    getUserProgress(),
                    getAgreedDataMigrationCompany(),
                    isMyCannabisPharmacySet(),
                ];
                Promise.all(promises)
                    .then(async ([info, progress, dataMigrationResponse, myCannabisPharmacyResponse,]) => {
                    setLoading(false);
                    if (info?.message?.response?.status === 401 || progress.error) {
                        dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
                        navigation.navigate('Login');
                        return;
                    }
                    const newUserInfo = { ...info.data, progress: progress.data };
                    setUserInfo(newUserInfo);
                    dispatch((0, reducers_1.setUserInformation)(newUserInfo));
                    if (auth.isTermsAgree &&
                        auth.isPrivacyPolicyAgree &&
                        dataMigrationResponse.data &&
                        !dataMigrationResponse.data.agreedDataMigrationCompany) {
                        const lastCheckDataMigration = await async_storage_1.default.getItem('TimeCheckDataMigration');
                        const actualDate = new Date();
                        const actualTimestamp = actualDate.getTime();
                        if (actualTimestamp - Number(lastCheckDataMigration) >
                            60000 * 1 // 30 minutes
                        ) {
                            setModalVisibleConfirmDataMigration(true);
                            const date = new Date();
                            await async_storage_1.default.setItem('TimeCheckDataMigration', date.getTime().toString());
                        }
                    }
                    if (!myCannabisPharmacyResponse.data.isMyCannabisPharmacySet &&
                        newUserInfo?.appointment?.length > 0) {
                        const lastCheckPharmacy = await async_storage_1.default.getItem('TimeCheckPharmacy');
                        const actualDate = new Date();
                        const actualTimestamp = actualDate.getTime();
                        if (actualTimestamp - Number(lastCheckPharmacy) >
                            60000 * 60 * 24 * 5 // 5 Tage
                        ) {
                            setModalVisiblePhmaracy(true);
                            const date = new Date();
                            await async_storage_1.default.setItem('TimeCheckPharmacy', date.getTime().toString());
                        }
                    }
                })
                    .catch(err => {
                    setLoading(false);
                    console.error(err);
                    //Maybe an alert here...
                    //Specify what should happen when the backend is unavailable for some reason...
                    //alert and redirect to login maybe??
                });
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.isAuthenticated]);
    const monthNames = [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ];
    const checkingData = (0, react_1.useMemo)(() => userInformation?.progress.total === 100 &&
        userInformation?.progress.isDataConfirm, [userInformation]);
    function handleScroll(event) {
        setToggleBarUp(false);
        const currentPosition = event.nativeEvent.contentOffset.y;
        setScrollPosition(currentPosition);
    }
    const onTherapyModalOk = () => {
        setTherapyModalVisible(false);
        navigateTo('PatientenTracking', { redirectPage: 'OnlineAppointment' });
    };
    const onTherapyModalCancel = () => setTherapyModalVisible(false);
    const onlineAppointmentCheckAndRedirect = () => {
        const WEEK_SPAN = 8.64e7 * 7; // <= milliseconds in a day * 7 days  = milliseconds in a week
        let newestDateEpoch = new Date(0).getTime();
        userInformation?.lifeQuality.forEach(row => {
            let { queryDate } = row;
            let queryDateEpoch = new Date(queryDate).getTime();
            if (queryDateEpoch > newestDateEpoch) {
                newestDateEpoch = queryDateEpoch;
            }
        });
        let now = Date.now();
        let weekBeforeNow = now - WEEK_SPAN;
        if (newestDateEpoch <= weekBeforeNow) {
            setTherapyModalVisible(true);
            return;
        }
        navigation.navigate('OnlineAppointment');
    };
    const filteredPatientAppointments = userInformation?.appointment?.filter(a => String(a.carriedOut) !== '2' && String(a.carriedOut) !== '3');
    // Condition for Stay Tuned Step on Current Steps
    // is now 10 minutes after last Appointment's endDate &&
    // carriedOut is not set
    const showStayTunedCurrentStep = userInformation?.progress.isDataConfirm &&
        filteredPatientAppointments?.length > 0 &&
        filteredPatientAppointments[filteredPatientAppointments.length - 1]
            .carriedOut === undefined &&
        new Date() >
            (0, date_fns_1.addMinutes)(new Date(filteredPatientAppointments[filteredPatientAppointments.length - 1]?.endDate), 10);
    const confirmDataMigration = () => {
        setModalVisibleConfirmDataMigration(false);
        User_service_1.default.approveDataMigrationCompany().then(res => {
            if (res.error) {
                console.log(res);
                return;
            }
        });
    };
    const navigateToPharmacySelection = () => {
        setModalVisiblePhmaracy(false);
        navigation.navigate('PharmacyListPage');
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
            react_1.default.createElement(react_native_1.SafeAreaView, { style: [Dashboard_web_style_1.styles.whiteBackground] },
                react_1.default.createElement(atome_1.Modal, { modalVisible: isModalVisiblePharmacy, setModalVisible: setModalVisiblePhmaracy, cb: navigateToPharmacySelection, primaryButtonText: "Jetzt Apotheken entdecken", secondaryButtonText: "Kein Interesse" },
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.alignCenter, GlobalStyles_1.globalStyles.marginBottom15] },
                        react_1.default.createElement(atome_1.Icon, { icon: 'pharmacysmall', size: 50, color: GlobalStyles_1.COLORS.green })),
                    react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.textBold, GlobalStyles_1.globalStyles.font16] }, "Wie zufrieden sind Sie mit Ihrer aktuellen Apotheke?"),
                    react_1.default.createElement(atome_1.Text, null, " "),
                    react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.alignCenter] },
                        react_1.default.createElement(atome_1.Text, { style: [
                                GlobalStyles_1.globalStyles.greenText,
                                GlobalStyles_1.globalStyles.marginRight10,
                                GlobalStyles_1.globalStyles.font16,
                            ] }, "\u2713"),
                        react_1.default.createElement(atome_1.Text, null, "Schnelle Lieferzeit")),
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.alignCenter,
                            GlobalStyles_1.globalStyles.marginTop10,
                        ] },
                        react_1.default.createElement(atome_1.Text, { style: [
                                GlobalStyles_1.globalStyles.greenText,
                                GlobalStyles_1.globalStyles.marginRight10,
                                GlobalStyles_1.globalStyles.font16,
                            ] }, "\u2713"),
                        react_1.default.createElement(atome_1.Text, null, "Kauf auf Rechnung")),
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.alignCenter,
                            GlobalStyles_1.globalStyles.marginTop10,
                        ] },
                        react_1.default.createElement(atome_1.Text, { style: [
                                GlobalStyles_1.globalStyles.greenText,
                                GlobalStyles_1.globalStyles.marginRight10,
                                GlobalStyles_1.globalStyles.font16,
                            ] }, "\u2713"),
                        react_1.default.createElement(atome_1.Text, null, "Pers\u00F6nlicher Telefon-Support")),
                    react_1.default.createElement(react_native_1.View, { style: [
                            GlobalStyles_1.globalStyles.row,
                            GlobalStyles_1.globalStyles.alignCenter,
                            GlobalStyles_1.globalStyles.marginTop10,
                        ] },
                        react_1.default.createElement(atome_1.Text, { style: [
                                GlobalStyles_1.globalStyles.greenText,
                                GlobalStyles_1.globalStyles.marginRight10,
                                GlobalStyles_1.globalStyles.font16,
                            ] }, "\u2713"),
                        react_1.default.createElement(atome_1.Text, null, "G\u00FCnstige Preise")),
                    react_1.default.createElement(atome_1.Text, null, " "),
                    react_1.default.createElement(atome_1.Text, null, "Dies sind typische Merkmale, die laut unseren Umfragen bei Apotheken besonders gesch\u00E4tzt werden."),
                    react_1.default.createElement(atome_1.Text, null, " "),
                    react_1.default.createElement(atome_1.Text, null, "Nicht 100% zufrieden? Sehen Sie sich jetzt die gefragtesten Online-Apotheken unserer Patienten an.")),
                react_1.default.createElement(atome_1.Modal, { modalVisible: isModalVisibleConfirmDataMigration, setModalVisible: setModalVisibleConfirmDataMigration, cb: confirmDataMigration, primaryButtonText: "Jetzt zustimmen", secondaryButtonText: "Sp\u00E4ter" },
                    react_1.default.createElement(atome_1.Text, { style: [
                            GlobalStyles_1.globalStyles.textAlignCenter,
                            GlobalStyles_1.globalStyles.greenText,
                            GlobalStyles_1.globalStyles.textBold,
                        ] }, "Wichtige Informationen zu Ihrem Nowomed-Konto"),
                    react_1.default.createElement(atome_1.Text, null, " "),
                    react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.textAlignCenter] }, "Im Rahmen unserer Neuausrichtung \u00FCbernimmt die nowohealth GmbH das operative Gesch\u00E4ft von der nowomed GmbH."),
                    react_1.default.createElement(atome_1.Text, null, " "),
                    react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.textAlignCenter] }, "Um unsere Angebote weiterhin nutzen zu k\u00F6nnen, bitten wir um Ihre Zustimmung."),
                    react_1.default.createElement(atome_1.Text, null, " "),
                    react_1.default.createElement(atome_1.Text, { style: [GlobalStyles_1.globalStyles.textAlignCenter] }, "Hiermit stimme ich ausdr\u00FCcklich zu, dass alle meine personenbezogenen Daten, insbesondere auch meine bei der nowomed GmbH vorliegenden Gesundheitsdaten an die nowohealth GmbH weitergegeben werden.")),
                react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
                (!userInformation || loading) && Breakpoints_1.isDesktop && react_1.default.createElement(atome_1.Loading, null),
                (!userInformation || loading) && Breakpoints_1.isMobileOrTablet && (react_1.default.createElement(react_native_1.View, { style: [Dashboard_web_style_1.styles.greenDotsContainer] },
                    react_1.default.createElement(atome_1.Loading, null))),
                userInformation && !loading && (react_1.default.createElement(react_native_1.ScrollView, { style: [Dashboard_web_style_1.styles.container], ref: aktuelRef, onScroll: handleScroll, scrollEventThrottle: 10 },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(react_native_1.View, { style: [Dashboard_web_style_1.styles.timelineContainer] },
                            react_1.default.createElement(react_native_1.View, { style: Dashboard_web_style_1.styles.timeline }),
                            react_1.default.createElement(AccountCreatedStep_component_1.AccountCreatedStep, { userInformation: userInformation, monthNames: monthNames }),
                            ((userInformation?.progress.isDataConfirm &&
                                filteredPatientAppointments?.length > 0) ||
                                (userInformation?.isAlreadyCannabisPatient &&
                                    filteredPatientAppointments?.length === 0) ||
                                userInformation.patientDataApproved) && (react_1.default.createElement(UserInformationStep_component_1.UserInformationStep, { userInformation: userInformation, monthNames: monthNames, navigateTo: navigateTo })),
                            !isPatientDeclined &&
                                userInformation?.progress.isDataConfirm &&
                                filteredPatientAppointments?.length > 0 &&
                                String(filteredPatientAppointments[0].carriedOut) ===
                                    '1' && (react_1.default.createElement(ThirdCircleStep_component_1.ThirdCircleStep, { userInformation: userInformation, monthNames: monthNames })),
                            !isPatientDeclined &&
                                userInformation?.progress.isDataConfirm &&
                                filteredPatientAppointments?.length > 1 &&
                                (isNextDay(filteredPatientAppointments[filteredPatientAppointments.length - 1].startDate) ||
                                    String(filteredPatientAppointments[filteredPatientAppointments.length - 1].carriedOut) === '1') && (react_1.default.createElement(FourthCircleStep_component_1.FourthCircleStep, { userInformation: userInformation })),
                            !isPatientDeclined &&
                                userInformation?.progress.isDataConfirm &&
                                filteredPatientAppointments?.length > 2 &&
                                !isNextDay(filteredPatientAppointments[filteredPatientAppointments.length - 1].startDate) &&
                                isNextDay(filteredPatientAppointments[filteredPatientAppointments.length - 2].startDate) && react_1.default.createElement(FifthCircleStep_component_1.FifthCircleStep, { userInformation: userInformation }),
                            react_1.default.createElement(react_native_1.View, { style: [
                                    Dashboard_web_style_1.styles.area,
                                    !Breakpoints_1.isMobileOrTablet ? Dashboard_web_style_1.styles.current : Dashboard_web_style_1.styles.mobileCurrent,
                                    isPatientDeclined ? { backgroundColor: '#FF991A' } : {},
                                ] },
                                !Breakpoints_1.isMobileOrTablet && (react_1.default.createElement(atome_1.Text, { style: [Dashboard_web_style_1.styles.heading2] }, "Aktuell")),
                                !isPatientDeclined &&
                                    (!userInformation?.progress.isDataConfirm ||
                                        filteredPatientAppointments?.length === 0 ||
                                        !filteredPatientAppointments) && (react_1.default.createElement(FirstCurrentStep_component_1.FirstCurrentStep, { userInformation: userInformation, checkingData: checkingData, navigateTo: navigateTo, toComplete: toComplete })),
                                !isPatientDeclined &&
                                    userInformation?.progress.isDataConfirm &&
                                    filteredPatientAppointments?.length > 0 &&
                                    !isNextDay(filteredPatientAppointments[0].startDate) &&
                                    String(filteredPatientAppointments[filteredPatientAppointments.length - 1].carriedOut) !== '1' &&
                                    !showStayTunedCurrentStep &&
                                    !userInformation?.isAlreadyCannabisPatient && (react_1.default.createElement(FourthCurrentStep_component_1.FourthCurrentStep, { userInformation: userInformation, scrollToAktuel: scrollToAktuel })),
                                !isPatientDeclined && showStayTunedCurrentStep && (react_1.default.createElement(StayTunedCurrentStep_web_component_1.StayTunedCurrentStep, { filteredPatientAppointments: filteredPatientAppointments, scrollToAktuel: scrollToAktuel })),
                                !isPatientDeclined &&
                                    userInformation?.progress.isDataConfirm &&
                                    !showStayTunedCurrentStep &&
                                    filteredPatientAppointments?.length > 0 &&
                                    (isNextDay(filteredPatientAppointments[filteredPatientAppointments?.length - 1].startDate) ||
                                        String(filteredPatientAppointments[filteredPatientAppointments.length - 1].carriedOut) === '1') && (react_1.default.createElement(ThirdCurrentStep_component_1.ThirdCurrentStep, { userInformation: userInformation, scrollToAktuel: scrollToAktuel, navigateTo: navigateTo, onlineAppointmentCheckAndRedirect: onlineAppointmentCheckAndRedirect, setShowFolgerezept: setShowFolgerezept })),
                                !isPatientDeclined &&
                                    ((userInformation?.progress.isDataConfirm &&
                                        filteredPatientAppointments?.length > 1 &&
                                        !isNextDay(filteredPatientAppointments[filteredPatientAppointments?.length - 1].startDate) &&
                                        String(filteredPatientAppointments[filteredPatientAppointments.length - 1].carriedOut) !== '1') ||
                                        (userInformation?.progress.isDataConfirm &&
                                            filteredPatientAppointments?.length > 0 &&
                                            !isNextDay(filteredPatientAppointments[0].startDate) &&
                                            String(filteredPatientAppointments[filteredPatientAppointments.length - 1].carriedOut) !== '1' &&
                                            userInformation?.isAlreadyCannabisPatient)) &&
                                    !showStayTunedCurrentStep && (react_1.default.createElement(FourthCurrentStep_component_1.FourthCurrentStep, { userInformation: userInformation, scrollToAktuel: scrollToAktuel })),
                                isPatientDeclined && (react_1.default.createElement(PatientDeclined_1.PatientDeclined, { scrollToAktuel: scrollToAktuel })),
                                !Breakpoints_1.isMobileOrTablet && (react_1.default.createElement(PhoneSupportDesktop_component_1.PhoneSupportDesktop, { navigateTo: navigateTo }))),
                            !isPatientDeclined &&
                                (filteredPatientAppointments?.length === 0 ||
                                    !filteredPatientAppointments) && (react_1.default.createElement(NextStepFirstAppointment_component_1.NextStepFirstAppointment, { userInformation: userInformation })),
                            !isPatientDeclined &&
                                !(userInformation?.progress.isDataConfirm &&
                                    filteredPatientAppointments?.length > 0 &&
                                    (isNextDay(filteredPatientAppointments[0].startDate) ||
                                        String(filteredPatientAppointments[0].carriedOut) ===
                                            '1')) && react_1.default.createElement(NextStepFirstAppointmentTookPlace_component_1.NextStepFirstAppointmentTookPlace, null),
                            !isPatientDeclined && react_1.default.createElement(NextStepLastStep_component_1.NextStepLastStep, null)),
                        Breakpoints_1.isMobileOrTablet && (react_1.default.createElement(PhoneSupportMobileTablet_component_1.PhoneSupportMobileTablet, { navigateTo: navigateTo }))))),
                react_1.default.createElement(organisms_1.TherapyMonitorModal, { visible: isTherapyModalVisible, onOk: onTherapyModalOk, onCancel: onTherapyModalCancel, purpose: "online-termin" })))));
}
exports.Dashboard = Dashboard;
